export { DeviceDesktop as default } from './DeviceDesktop';
